module.exports = __webpack_public_path__ + "static/commerce2x-rtl-support-10539c6539ae42f8408207584181c62d.png";